import { useContext, useCallback } from "react";
import { TrackingContext } from "../components/managers";
import { EVENT_TYPE } from "../event_conf";
import { IS_EXCLUSIVELY_SNOWPLOW_EVENT } from "../utils/snowplowEventMigrator";

export const eventTypes = EVENT_TYPE;
export const throttleRates = {
	[eventTypes.PAGE_LOAD]: 4000,
	[eventTypes.WIDGET_LOAD]: 4000,
};

export default function useTrack() {
	const push = useContext(TrackingContext);
	const track = useCallback(
		(name, properties = {}) => {
			if (
				!(name in eventTypes) &&
				!IS_EXCLUSIVELY_SNOWPLOW_EVENT.has(name)
			) {
				// Early return if the triggered value is not a Mixpanel or exclusively Snowplow event
				// console.log("return", name); // Disable log for production
				return false;
			}

			push({
				name,
				properties,
			});
			return true;
		},
		[push]
	);
	return track;
}
